import rootLogger from '@/utils/root-logger';
import * as LDClient from "launchdarkly-js-client-sdk";
const logger = rootLogger.create('vuex-modules/features');

const mutations = {
  setRegistrationExpRebranding(state, payload) {
    state.registrationExperience = payload.registrationExperience;
    state.isRebranding = payload.isRebranding;
  },
}
let ldClient;
const actions = {
  async initialize({rootState, commit}) {
    if (!ldClient) {
      const user = {
        key: rootState.g2wEnv.machineId,
        anonymous: true
      };
      const clientId = rootState.g2wEnv.current.launchdarklyClientId;

      // https://docs.launchdarkly.com/docs/js-sdk-reference#section-initializing-the-client
      ldClient = LDClient.initialize(clientId, user);
      try {
        await ldClient.waitForInitialization();
        logger.log('Launch Darkly initialized', {clientId, user});
        // initialization succeeded, flag values are now available
        const registrationExperience = ldClient.variation('registration-experience', 'NoPlayButton');
        const isRebranding = ldClient.variation('rebranding');
        commit('setRegistrationExpRebranding', {registrationExperience, isRebranding});
      } catch (err) {
        // initialization failed
        logger.log('Launch Darkly initialization error', err);
      }
    }
  }
}
const state = () => ({
  registrationExperience: null,
  isRebranding: null
});
export default {
  namespaced: true,
  mutations,
  actions,
  state
};
